
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullDegreePartner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Partner_Partner"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rectangularLogo"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Degree_RGBAColor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alpha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"red"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"green"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hexCode"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullDegree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Degree_Degree"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dtdId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmlValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"headerImageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportEmailAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internalLaunchType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headerBackgroundColor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Degree_LinearGradient2Colors"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color1"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullColor"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"color2"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullColor"},"directives":[]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Degree_RGBAColor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullColor"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullDegreePartner"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DegreeHomeDegreeBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Degree"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullDegree"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":767}};
    doc.loc.source = {"body":"fragment FullDegreePartner on Partner_Partner {\n  id\n  name\n  rectangularLogo\n}\n\nfragment FullColor on Degree_RGBAColor {\n  alpha\n  red\n  blue\n  green\n  hexCode\n}\n\nfragment FullDegree on Degree_Degree {\n  id\n  slug\n  name\n  description {\n    dtdId\n    cmlValue\n  }\n  headerImageUrl\n  supportEmailAddress\n  supportLink\n  locale\n  productVariant\n  internalLaunchType\n  headerBackgroundColor {\n    __typename\n    ... on Degree_LinearGradient2Colors {\n      color1 {\n        ...FullColor\n      }\n      color2 {\n        ...FullColor\n      }\n    }\n    ... on Degree_RGBAColor {\n      ...FullColor\n    }\n  }\n  partners {\n    ...FullDegreePartner\n  }\n}\n\nquery DegreeHomeDegreeBySlug($slug: String!) {\n  Degree {\n    queryBySlug(slug: $slug) {\n      ...FullDegree\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FullDegreePartner"] = oneQuery(doc, "FullDegreePartner");
        
        module.exports["FullColor"] = oneQuery(doc, "FullColor");
        
        module.exports["FullDegree"] = oneQuery(doc, "FullDegree");
        
        module.exports["DegreeHomeDegreeBySlug"] = oneQuery(doc, "DegreeHomeDegreeBySlug");
        
